<template>
  <div>

    <!-- <b-card-code title="Cari Data">
      <div class="form-group row">
        <label class="col-2 col-form-label">Cabang</label>
        <div class="col-3">
          <BranchListComponent :value="filter.branchId" @value="filter.branchId = $event"/>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-2 col-form-label">Departemen</label>
        <div class="col-3">
          <DepartmentComponent :value="filter.branchId" @value="filter.branchId = $event"/>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-2 col-form-label">Grade</label>
        <div class="col-3">
          <GradeComponent :value="filter.branchId" @value="filter.branchId = $event"/>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-2 col-form-label">Nama</label>
        <div class="col-3">
          <b-form-input placeholder="" v-model="filter.paramName" />
        </div>
      </div>
    </b-card-code> -->

    <b-card-code title="Daftar Karyawan">
      <b-row>
        <b-col md="4" class="mb-1">
          <b-form-input placeholder="Cari" v-model="filter.fullName" />
        </b-col>
        <b-col class="mb-1 text-right">
          <FormEmployee
            :is-loading="isLoading"
            :edit-id="editId"
            :validations="validations"
            :create-item="createItem"
            :update-item="updateItem"
            :clean-up-form="cleanUpForm"
            :edit-payload="formPayload"
            :form-payload="formPayload"
            :genders="genders"
            :religions="religions"
            :marital-status="maritalStatus"
            :ptkp="ptkp"
            :employee-status="employeeStatus"
            :province="province"
            @payloadEmployee="getPayload($event)"
          />
        </b-col>
      </b-row>

      <ListEmployee
        :result="result"
        :is-loading="isLoading"
        :get-category-data="getData"
        :edit-item="editItem"
        :delete-item="deleteItem"
        :detail-item="detailItem"
        :handle-page-change="handlePageChange"
      />
    </b-card-code>
  </div>
</template>

<script>
import _ from "lodash";
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
import {
  BButton,
  BTable,
  BFormGroup,
  BPagination,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BSpinner,
  BRow,
  BCol,
} from "bootstrap-vue";
import { successNotification, errorNotification } from "@/auth/utils";
import Ripple from "vue-ripple-directive";

import ListEmployee from "@/components/Employee/ListEmployee.vue";
import FormEmployee from "@/components/Employee/FormEmployee.vue";
import BranchListComponent from "@/components/Base/BranchListComponent.vue";
import DepartmentComponent from "@/components/Base/DepartmentComponent.vue";
import GradeComponent from "@/components/Base/GradeComponent.vue";

export default {
  components: {
    BCardCode,
    BButton,
    BTable,
    BFormGroup,
    BPagination,
    BFormInput,
    BFormTextarea,
    BFormFile,
    BSpinner,
    BRow,
    BCol,
    ListEmployee,
    FormEmployee,
    BranchListComponent,
    DepartmentComponent,
    GradeComponent
},
  directives: {
    Ripple,
  },
  watch: {
    filter: {
      handler: _.debounce(function (value) {
        this.getData();
      }, 300),
      deep: true,
    },
  },

  setup(props) {
    return {
      successNotification,
      errorNotification,
    };
  },
  data() {
    return {
      result: {},
      isLoading: false,
      validations: {},
      formPayload: Object,
      editId: null,
      categoryName: "",
      parent: {},
      detail: {},
      filter: {
        fullName: "",
      },
      imageEmployee: null,
      genders: Array,
      religions: Array,
      maritalStatus: Array,
      ptkp: Array,
      employeeStatus: Array,
      province: Array,
    };
  },
  created() {
    this.getData();
    this.getGenders();
    this.getReligions();
    this.getMaritalStatus();
    this.getPtkp();
    this.getEmployeeStatus();
    this.getProvinceData();
  },
  methods: {
    getPayload(value) {
      if (value) {
        this.formPayload = value;
      }
    },
    cleanUpForm() {
      this.editId = null;
      this.imageEmployee = null;
      this.formPayload = {
        address: "",
        basicSalary: 0,
        childQuantity: 0,
        dateOfBirth: "",
        dateResign: "",
        email: "",
        employeeNumber: "",
        employeeStatusId: 0,
        fullName: "",
        genderId: 0,
        // imageProfile: "",
        joinDate: "",
        legalId: "",
        maritalStatusId: 0,
        npwp: "",
        phoneNumber: "",
        placeOfBirth: "",
        ptkp: 0,
        religionId: 0,
        spouseName: "",
        telephone: "",
        villageId: 0,
      };
      this.validations = "";
    },
    handlePageChange(value) {
      this.getData(value);
    },
    detailItem(id) {
      this.$router.push({ name: "employee-master.show", params: { id } });
    },
    createItem() {
      this.getPayload();
      const form = this.formPayload;
      this.isLoading = true;

      this.$http
        .post("/employee", form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          if (response.data.code == "00") {
            this.$bvModal.hide("form-employee-modal");
            this.getData();
            successNotification(this, "Success", "Karyawan berhasil di buat");
            this.cleanUpForm();
          } else {
            errorNotification(this, "Oops!", response.data.message);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          errorNotification(this, "Oops!", error.response.data.message);

          this.isLoading = false;
        });
    },
    updateItem() {
      const form = this.formPayload;
      this.isLoading = true;

      this.$http
        .put(`/employee/${this.editId}`, form, {
          headers: { "content-type": "application/json" },
        })
        .then((response) => {
          this.$bvModal.hide("form-employee-modal");
          this.getData();
          successNotification(this, "Success", "Karyawan berhasil di ubah!");
          this.cleanUpForm();
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.data.meta.validations) {
            this.validations = error.response.data.meta.validations;
            errorNotification(this, "Oops!", error.response.data.meta.messages);
          }
          this.isLoading = false;
        });
    },
    preparePayload() {
      const form = new FormData();
      for (const key in this.formPayload) {
        if (
          this.formPayload.hasOwnProperty(key) &&
          this.formPayload[key] != null
        ) {
          form.append(key, this.formPayload[key]);
        }
      }

      return form;
    },
    editItem(item) {
      this.cleanUpForm();
      this.editId = item.employeeId;
      this.imageEmployee = item.file;
      this.formPayload = {
        address: item.address,
        basicSalary: item.basicSalary,
        childQuantity: item.childQuantity,
        dateOfBirth: item.dateOfBirth,
        dateResign: item.dateResign,
        email: item.email,
        employeeNumber: item.employeeNumber,
        employeeStatusId: item.employeeStatus
          ? item.employeeStatus.paramListId
          : item.employeeStatus,
        fullName: item.fullName,
        genderId: item.gender ? item.gender.paramListId : item.gender,
        imageProfile: item.imageProfile,
        joinDate: item.joinDate,
        legalId: item.legalId,
        maritalStatusId: item.maritalStatus
          ? item.maritalStatus.paramListId
          : item.maritalStatus,
        npwp: item.npwp,
        phoneNumber: item.phoneNumber,
        placeOfBirth: item.placeOfBirth,
        ptkp: item.ptkp ? item.ptkp.paramListId : 0,
        religionId: item.religion ? item.religion.paramListId : item.religion,
        spouseName: item.spouseName,
        telephone: item.telephone,
        provinceId: item.village
          ? item.village.district.city.province.provinceId
          : null,
        cityId: item.village ? item.village.district.city.cityId : null,
        districtId: item.village ? item.village.district.districtId : null,
        villageId: item.village ? item.village.villageId : null,
      };
      this.$bvModal.show("form-employee-modal");
    },
    deleteItem(id) {
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(`/employee/${id}`)
            .then((response) => {
              this.getData(this.currentPage);
              this.$swal({
                icon: "success",
                title: "Berhasil!",
                text: "Karyawan berhasil di hapus",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            })
            .catch((error) => {
              console.log("error");
              console.log(error);
            });
        }
      });
    },
    getData(page = 1) {
      this.isLoading = true;
      const queryParams = this.filter;
      queryParams.page = page;
      this.$http
        .get("/employee/findAll", {
          params: queryParams,
        })
        .then((response) => {
          this.result = response.data.data;
          this.isLoading = false;
        });
    },
    getGenders() {
      this.$http
        .get("/mastering/systemParameterList/findAll", {
          params: {
            paramSystemName: "GENDER",
          },
        })
        .then((response) => {
          let result = response.data.data.content;
          for (let i = 0; i < result.length; i++) {
            result[i].value = result[i].paramListId;
            result[i].text = result[i].paramListDesc;
            delete result[i].key;
            delete result[i].label;
          }

          this.genders = result;
          this.genders.unshift({ value: "", text: "Pilih Jenis Kelamin" });
        });
    },
    getReligions() {
      this.$http
        .get("/mastering/systemParameterList/findAll", {
          params: {
            paramSystemName: "RELIGION",
          },
        })
        .then((response) => {
          let result = response.data.data.content;
          for (let i = 0; i < result.length; i++) {
            result[i].value = result[i].paramListId;
            result[i].text = result[i].paramListDesc;
            delete result[i].key;
            delete result[i].label;
          }

          this.religions = result;
          this.religions.unshift({ value: "", text: "Pilih Agama" });
        });
    },
    getMaritalStatus() {
      this.$http
        .get("/mastering/systemParameterList/findAll", {
          params: {
            paramSystemName: "MARITAL_STATUS",
          },
        })
        .then((response) => {
          let result = response.data.data.content;
          for (let i = 0; i < result.length; i++) {
            result[i].value = result[i].paramListId;
            result[i].text = result[i].paramListDesc;
            delete result[i].key;
            delete result[i].label;
          }

          this.maritalStatus = result;
          this.maritalStatus.unshift({
            value: "",
            text: "Pilih Status Perkawinan",
          });
        });
    },
    getPtkp() {
      this.$http
        .get("/mastering/systemParameterList/findAll", {
          params: {
            paramSystemName: "PTKP_TYPE",
          },
        })
        .then((response) => {
          let result = response.data.data.content;
          for (let i = 0; i < result.length; i++) {
            result[i].value = result[i].paramListId;
            result[i].text = result[i].paramListDesc;
            delete result[i].key;
            delete result[i].label;
          }

          this.ptkp = result;
          this.ptkp.unshift({ value: "", text: "Pilih PTKP" });
        });
    },
    getEmployeeStatus() {
      this.$http
        .get("/mastering/systemParameterList/findAll", {
          params: {
            paramSystemName: "EMPLOYEE_STATUS",
          },
        })
        .then((response) => {
          let result = response.data.data.content;
          for (let i = 0; i < result.length; i++) {
            result[i].value = result[i].paramListId;
            result[i].text = result[i].paramListDesc;
            delete result[i].key;
            delete result[i].label;
          }

          this.employeeStatus = result;
          this.employeeStatus.unshift({
            value: "",
            text: "Pilih Status Karyawan",
          });
        });
    },
    getProvinceData() {
      const queryParams = {
        size: 50,
      };
      this.$http
        .get("/mastering/province/all", { params: queryParams })
        .then((response) => {
          let result = response.data.data;

          for (let i = 0; i < result.length; i++) {
            result[i].value = result[i].provinceId;
            result[i].text = result[i].provinceName;
            delete result[i].key;
            delete result[i].label;
          }

          this.province = result;
        });
    },
  },
};
</script>
